import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

import { Chequereceipt } from "./chequereceipt.model";

@Injectable({
  providedIn: 'root'
})
export class ChequereceiptService {

  selectedChequereceipt : Chequereceipt;
  selectedChequereceiptList :Chequereceipt[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {
    return environment.baseUrl;
  }

  IUDChequeReceipt(chequereceipt:Chequereceipt){

    var body = JSON.stringify(chequereceipt);
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/ChequeReceipt/IUD', body, { headers: headers });
  
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/ChequeReceipt/IUD', body, requestOptions).map(x => x.json());
  }

  FetchChequeReceiptByReceiptNo(chequereceipt) {
    var body = JSON.stringify(chequereceipt);
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/ChequeReceipt/Fetch', body, requestOptions).map(x => x.json());
    
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/ChequeReceipt/Fetch', body, { headers: headers });
  
  }

  GetChequeReceiptTypeList(){
    var body = JSON.stringify('');
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/CommonMaster/ChequeReceiptType', body, requestOptions).map(x => x.json());
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/ChequeReceiptType', body, { headers: headers });
  
  }

  GetBankingTypeList(){
    var body = JSON.stringify('');
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/CommonMaster/BankingType', body, requestOptions).map(x => x.json());
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/BankingType', body, { headers: headers });
  
  }

  GetAgentList(){
    var body = JSON.stringify('');
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/CommonMaster/Agent', body, requestOptions).map(x => x.json());
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/Agent', body, { headers: headers });
  
  }

//-----------------------------EnquiryEntryList----Component-------------------------------------
  FetchChequeReceiptList(){
    var body = JSON.stringify('');
    var headerOptions = new Headers({ 'Content-Type': 'application/json' });
    // var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
    // return this.http.post(this.getBaseUrl() + 'api/ChequeReceipt/FetchList', body, requestOptions).map(x => x.json());
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/FetchList', body, { headers: headers });
  
  }

}
